import React, { useState } from 'react';

const ContactSection = () => {
  const [status, setStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = new FormData(e.target);

    const response = await fetch("https://formspree.io/f/xvgrvqoq", {
      method: "POST",
      headers: {
        Accept: "application/json",
      },
      body: form,
    });

    if (response.ok) {
      setStatus("SUCCESS");
      e.target.reset();
    } else {
      setStatus("ERROR");
    }
  };

  return (
    <section id="contact" className="bg-gray-50 py-20">
      <div className="container mx-auto px-4 max-w-3xl">
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-6">
          Contactez-nous
        </h2>
        <p className="text-center text-gray-600 mb-10">
          Une question, un besoin spécifique ? Envoyez-nous un message et nous reviendrons vers vous rapidement.
        </p>

        {status === "SUCCESS" ? (
          <div className="bg-green-100 border border-green-300 text-green-800 p-4 rounded text-center">
            Merci ! Votre message a bien été envoyé.
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow-md p-8 space-y-6">
            <div>
              <label className="block text-sm font-medium text-gray-700">Nom</label>
              <input
                type="text"
                name="name"
                required
                className="mt-1 w-full border border-gray-300 rounded-md p-3 focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Email</label>
              <input
                type="email"
                name="email"
                required
                className="mt-1 w-full border border-gray-300 rounded-md p-3 focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Message</label>
              <textarea
                name="message"
                rows="5"
                required
                className="mt-1 w-full border border-gray-300 rounded-md p-3 focus:ring-2 focus:ring-blue-500"
              ></textarea>
            </div>

            <button
              type="submit"
              className="w-full bg-blue-600 text-white font-semibold py-3 rounded-md hover:bg-blue-700 transition"
            >
              Envoyer
            </button>
          </form>
        )}

        {status === "ERROR" && (
          <p className="text-red-600 text-sm mt-4 text-center">
            Une erreur est survenue. Veuillez réessayer plus tard.
          </p>
        )}
      </div>
    </section>
  );
};

export default ContactSection;
